import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var Expectation = /*#__PURE__*/function () {
  function Expectation() {
    _classCallCheck(this, Expectation);
  }

  _createClass(Expectation, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value >= this.minPercentage && value <= this.maxPercentage;
    }
  }]);

  return Expectation;
}();

_defineProperty(Expectation, "minPercentage", 0);

_defineProperty(Expectation, "maxPercentage", 100);